module.exports = __webpack_public_path__ + "static/media/clock.b370e2e9.svg";